module.exports = __webpack_public_path__ + "img/-1_1.b5279590.svg";